import React from 'react';
import styles from './LoadingOverlay.module.css';
import { KatSpinner } from '@amzn/katal-react';

interface LoadingOverlayProps {
  /**
   * The text to display below the spinner
   */
  text: string;
}

/**
 * A full-screen loading overlay component that displays a centered KatSpinner
 * with customizable text below it.
 */
export const LoadingOverlay: React.FC<LoadingOverlayProps> = ({ text }) => {
  return (
    <div className={styles.container}>
      <div className={styles.content} role="status" aria-live="polite">
        <KatSpinner size="large" data-testid="loading-spinner" />
        <div className={styles.text}>{text}</div>
      </div>
    </div>
  );
};
